import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import AntifraudRecipientNotifyModal from 'apps/auth/components/history/send/cheque/modals/AntifraudRecipientNotifyModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AF_MORE_INFO_ABOUT_RECIPIENT_CONTINUE_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCENARIO_ID } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const AntiFraudNotifyRecipientPage = (props) => {
    const messages = usePageMessages();
    const extra = useExtra();

    const onContinueIntro = () => {
        amplitude.getInstance().logEvent(AF_MORE_INFO_ABOUT_RECIPIENT_CONTINUE_CLICKED, { [SCENARIO_ID]: extra.fraudScenarioId });
        props.toggleModal(true, <AntifraudRecipientNotifyModal extra={extra} shareDetails={extra.shareDetails} />);
    };

    return (
        <CommonPage>
            <InfoPage
                iconName="id-card-80"
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={messages.introHeaderTitle} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={messages.introText} />}
                primaryButtonCaption={messages.continueButton}
                topButtonCaption={messages.notNowButton}
                topButtonType="link"
                topButtonLink={AUTH_SEND_MAIN_LINK}
                primaryButtonOnClick={onContinueIntro}
            />
        </CommonPage>
    );
};

export default connect(null, {
    toggleChat,
    toggleModal,
})(BasePage(AntiFraudNotifyRecipientPage));
